// import React from "react";
// import CustomButton from "../../../../atoms/CustomButton";
// import { Repeat } from "lucide-react";
// import Modal from "../../../../organisms/modals/Modal";
// import DeleteModal from "../../../../organisms/modals/DeleteModal";
// import { useState } from "react";
// import SelectDropdown from "../../../../molecules/Dropdown";
// import { Form } from "formik";
// import { DateSelector } from "../../../../organisms/MonthYearSelector";

// import { frequencyOptions } from "../../../../../helpers/staticData";
// import { postData } from "../../../../../services";
// import { useCookies } from "react-cookie";
// import toast from "react-hot-toast";
// import {
//   confimationStyles,
//   errorStyles,
// } from "../../../../../assets/styles/toast";

// const RecurringForm = ({
//   setOpen,
//   task_id,
//   setFieldValue,
//   values,
//   resetForm,
//   isSubmitting,
//   handleSubmit,
// }) => {
//   const [formData, setFormData] = useState({
//     recurrence_type: values?.recurrence_type || "",
//     start_date: values?.start_date || null,
//     end_time: values?.end_time || null,
//   });

//    const [cookies] = useCookies(["e_t", "euid", "e_n"]);

//   // Handle input changes internally
//   const handleChange = (field, value) => {
//     setFormData((prev) => ({ ...prev, [field]: value }));
//   };

//   // Apply formData to Formik state on save
//   const handleSave = async () => {
//     if (!values?.id) {
//       setFieldValue("recurrence_type", formData.recurrence_type);
//       setFieldValue("start_date", formData.start_date);
//       setFieldValue("end_time", formData.end_time);
//     } else {

//       try{
//         const res = await postData({
//           endpoint: "Task/createRecurringTask",
//           data: {
//             task_id: values?.id,
//             is_recurring: true,
//             recurrence_type: formData?.recurrence_type,
//             start_date: formData?.start_date,
//             end_time: formData?.end_time,
//           },
//           token: cookies.e_t,
//         });
//       } catch (err) {
//         toast.error('Error creating recurring tasks',{duration: 1500})
//       }
    

//       setFieldValue("recurrence_type", formData.recurrence_type);
//       setFieldValue("start_date", formData.start_date);
//       setFieldValue("end_time", formData.end_time);

//     }

//     setOpen(false);
//   };

//   const isSaveDisabled =
//     !formData.recurrence_type || !formData.start_date || !formData.end_time;

//   return (
//     <Form>
//       <div className="mb-4 d-flex align-items-center">
//         <label className="w-40 font-medium required-field">
//           Recurrence Type
//         </label>
//         <div className="w-60">
//           <SelectDropdown
//             onChange={(option) => handleChange("recurrence_type", option)}
//             data={frequencyOptions}
//             placeholder="Select Recurrence Type"
//             selectedValue={values?.recurrence_type}
//           />
//         </div>
//       </div>

//       <div className="mb-4 d-flex align-items-center">
//         <label className="w-40 font-medium required-field">
//           Starting from{" "}
//         </label>
//         <div className="w-60">
//           <DateSelector
//             onChange={(date) => handleChange("start_date", date)}
//             selectedDate={values?.start_date}
//             disablePast
//           />
//         </div>
//       </div>

//       <div className="mb-4 d-flex align-items-center">
//         <label className="w-40 font-medium required-field">Ends </label>
//         <div className="w-60">
//           <DateSelector
//             onChange={(date) => handleChange("end_time", date)}
//             selectedDate={values?.end_time}
//             disablePast
//           />
//         </div>
//       </div>

//       <div className="modal-footer mt-4 px-4">
//         <button
//           type="button"
//           className="btn btn-outline-primary"
//           onClick={() => setOpen(false)}
//         >
//           Cancel
//         </button>

//         <button
//           type="button"
//           className="btn btn-primary"
//           disabled={isSubmitting || isSaveDisabled}
//           onClick={handleSave}
//         >
//           Save
//         </button>
//       </div>
//     </Form>
//   );
// };

// const Recurring = ({ task_id, setFieldValue, values }) => {
//   const [cookies] = useCookies(["e_t"]);
//   const [open, setOpen] = useState(false);
//   const [endRepeat, setEndRepeat] = useState(false);

//   const handleEndRepeats = async () => {
//     try {
//       const res = await postData({
//         endpoint: "Task/endRepeats",
//         params: { task_id: values?.id },
//         token: cookies.e_t,
//       });

//       setFieldValue("recurrence_type", null);
//       setFieldValue("start_date", null);
//       setFieldValue("end_time", null);

//       if (res) {
//         toast.success("Repeats ended successfully", {
//           style: confimationStyles,
//           duration: 1000,
//         });
//       }

//       setEndRepeat(false)
//     } catch (err) {
//       toast.error("An error occured", { duration: 1000, style: errorStyles });
//     }
//   };

//   return (
//     <>
//       {values?.is_recurring ? (
//         <CustomButton
//           icon={<Repeat size={14} />}
//           text="End Repeats"
//           handleClick={() => setEndRepeat(true)}
//         />
//       ) : (
//         <CustomButton
//           icon={<Repeat size={14} />}
//           text="Set Repeats"
//           handleClick={() => setOpen(true)}
//         />
//       )}

//       {open && (
//         <Modal
//           title={"Set Repeats"}
//           setOpen={setOpen}
//           isActive={open}
//           onClose={() => setOpen(false)}
//           width="500px"
//         >
//           <RecurringForm
//             setFieldValue={setFieldValue}
//             values={values}
//             task_id={task_id}
//             setOpen={setOpen}
//           />
//         </Modal>
//       )}

//       {endRepeat && (
//         <DeleteModal
//           isActive={endRepeat}
//           onClose={() => setEndRepeat(false)}
//           type="End Repeats"
//           description={"Are you sure you want to end repeats for this task."}
//           onClick={handleEndRepeats}
//         />
//       )}
//     </>
//   );
// };

// export default Recurring;


// import React from "react";
// import CustomButton from "../../../../atoms/CustomButton";
// import { Repeat } from "lucide-react";
// import Modal from "../../../../organisms/modals/Modal";
// import DeleteModal from "../../../../organisms/modals/DeleteModal";
// import { useState } from "react";
// import SelectDropdown from "../../../../molecules/Dropdown";
// import { Form } from "formik";
// import { DateSelector } from "../../../../organisms/MonthYearSelector";
// import { frequencyOptions } from "../../../../../helpers/staticData";

// const RecurringForm = ({ setOpen, setFieldValue, values }) => {
//   const [formData, setFormData] = useState({
//     recurrence_type: values?.recurrence_type || "",
//     start_date: values?.start_date || null,
//     end_time: values?.end_time || null,
//   });

//   // Handle input changes internally
//   const handleChange = (field, value) => {
//     setFormData((prev) => ({ ...prev, [field]: value }));
//   };

//   // Apply formData to Formik state on save, no API calls
//   const handleSave = () => {
//     setFieldValue("recurrence_type", formData.recurrence_type);
//     setFieldValue("start_date", formData.start_date);
//     setFieldValue("end_time", formData.end_time);
//     setOpen(false);
//   };

//   const isSaveDisabled =
//     !formData.recurrence_type || !formData.start_date || !formData.end_time;

//   return (
//     <Form>
//       <div className="mb-4 d-flex align-items-center">
//         <label className="w-40 font-medium required-field">
//           Recurrence Type
//         </label>
//         <div className="w-60">
//           <SelectDropdown
//             onChange={(option) => handleChange("recurrence_type", option)}
//             data={frequencyOptions}
//             placeholder="Select Recurrence Type"
//             selectedValue={formData.recurrence_type}
//           />
//         </div>
//       </div>

//       <div className="mb-4 d-flex align-items-center">
//         <label className="w-40 font-medium required-field">
//           Starting from{" "}
//         </label>
//         <div className="w-60">
//           <DateSelector
//             onChange={(date) => handleChange("start_date", date)}
//             selectedDate={formData.start_date}
//             disablePast
//           />
//         </div>
//       </div>

//       <div className="mb-4 d-flex align-items-center">
//         <label className="w-40 font-medium required-field">Ends </label>
//         <div className="w-60">
//           <DateSelector
//             onChange={(date) => handleChange("end_time", date)}
//             selectedDate={formData.end_time}
//             disablePast
//           />
//         </div>
//       </div>

//       <div className="modal-footer mt-4 px-4">
//         <button
//           type="button"
//           className="btn btn-outline-primary"
//           onClick={() => setOpen(false)}
//         >
//           Cancel
//         </button>

//         <button
//           type="button"
//           className="btn btn-primary"
//           disabled={isSaveDisabled}
//           onClick={handleSave}
//         >
//           Save
//         </button>
//       </div>
//     </Form>
//   );
// };

// const Recurring = ({ setFieldValue, values, setEndRepeats }) => {
//   const [open, setOpen] = useState(false);

//   const handleEndRepeats = () => {
//     setFieldValue("recurrence_type", null);
//     setFieldValue("start_date", null);
//     setFieldValue("end_time", null);
//     setEndRepeats(true);
//     setOpen(false);
//   };

//   return (
//     <>
//       {values?.is_recurring ? (
//         <CustomButton
//           icon={<Repeat size={14} />}
//           text="End Repeats"
//           handleClick={() => setOpen(true)}
//         />
//       ) : (
//         <CustomButton
//           icon={<Repeat size={14} />}
//           text="Set Repeats"
//           handleClick={() => setOpen(true)}
//         />
//       )}

      

//       {open && values?.is_recurring ? (
//         <DeleteModal
//           isActive={open}
//           onClose={() => setOpen(false)}
//           type="End Repeats"
//           description={"Are you sure you want to end repeats for this task."}
//           onClick={handleEndRepeats}
//         />
//       ) : (
//         open && (
//           <Modal
//             title={"Set Repeats"}
//             setOpen={setOpen}
//             isActive={open}
//             onClose={() => setOpen(false)}
//             width="500px"
//           >
//             <RecurringForm
//               setFieldValue={setFieldValue}
//               values={values}
//               setOpen={setOpen}
//             />
//           </Modal>
//         )
//       )}
//     </>
//   );
// };

// export default Recurring;


import React, { useState, useEffect } from "react";
import { Repeat, Plus, Minus, Calendar } from "lucide-react";
import Modal from "../../../../organisms/modals/Modal";
import DeleteModal from "../../../../organisms/modals/DeleteModal";
import CustomButton from "../../../../atoms/CustomButton";
import SelectDropdown from "../../../../molecules/Dropdown";
import { DateSelector } from "../../../../organisms/MonthYearSelector"; // Update with correct path
import './styles.scss';
import { v4 as uuidv4 } from "uuid";
import CheckboxWrapper from "../../../../atoms/CheckBoxWrapper/Checkbox";
import * as Yup from "yup";
import Error from "../../../../atoms/Error";

// Validation schema for recurring form
const recurringValidationSchema = Yup.object().shape({
  recurrence_type: Yup.string().required("Recurrence type is required"),
  start_date: Yup.date().when('start_date_option', {
    is: 'custom',
    then: (schema) => schema.required("Start date is required when custom option is selected"),
    otherwise: (schema) => schema.nullable()
  }),
  end_time: Yup.date().required("Repeat end date is required"),
  custom_due_date_offset: Yup.number().when('due_date_option', {
    is: 'custom',
    then: (schema) => schema.required("Custom due date offset is required").min(0, "Offset must be 0 or greater"),
    otherwise: (schema) => schema.nullable()
  }),
  repeat_interval: Yup.number().required("Repeat interval is required").min(1, "Repeat interval must be at least 1"),
});

const RecurringForm = ({ setModalState, setFieldValue, values, status }) => {
  const [formData, setFormData] = useState({
    is_recurring: values?.is_recurring || true,
    recurrence_type: values?.recurrence_type || "daily",
    start_date: values?.start_date || null,
    end_time: values?.end_time || null,
    repeat_interval: values?.repeat_interval || 1,
    week_days: values?.week_days && Array.isArray(values.week_days) ? values.week_days : Array(7).fill(false),
    month_days: values?.month_days && Array.isArray(values.month_days) ? values.month_days : Array(31).fill(false),
    skip_weekends: values?.skip_weekends || false,
    due_date_offset: values?.due_date_offset || "same_day",
    custom_due_date_offset: values?.custom_due_date_offset || null,
    end_condition: values?.end_condition || "end_date",
    start_date_option: values?.start_date ? "custom" : "tomorrow",
    due_date_option: values?.due_date_offset || "same_day",
    default_status: values?.default_status || "New Task",
  });

  // Count selected days
  const [weekDaysCount, setWeekDaysCount] = useState(0);
  const [monthDaysCount, setMonthDaysCount] = useState(0);
  const [validationErrors, setValidationErrors] = useState({});
  const [showValidationErrors, setShowValidationErrors] = useState(false);

  // Initialize counts on component mount and when values change
  useEffect(() => {
    const weekCount = formData.week_days ? formData.week_days.filter(Boolean).length : 0;
    const monthCount = formData.month_days ? formData.month_days.filter(Boolean).length : 0;
    setWeekDaysCount(weekCount);
    setMonthDaysCount(monthCount);
  }, [formData.week_days, formData.month_days]);

  // Only validate form for internal validation state, don't show errors immediately
  useEffect(() => {
    if (showValidationErrors) {
      validateForm();
    }
  }, [formData, showValidationErrors]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleWeekDayToggle = (dayIndex) => {
    setFormData((prev) => {
      const newWeekDays = [...prev.week_days];
      const wasSelected = newWeekDays[dayIndex];
      newWeekDays[dayIndex] = !newWeekDays[dayIndex];

      // Update count
      if (wasSelected) {
        setWeekDaysCount(count => count - 1);
      } else {
        setWeekDaysCount(count => count + 1);
      }

      return { ...prev, week_days: newWeekDays };
    });
  };

  const handleMonthDayToggle = (dayIndex) => {
    setFormData((prev) => {
      const newMonthDays = [...prev.month_days];
      const wasSelected = newMonthDays[dayIndex];
      newMonthDays[dayIndex] = !newMonthDays[dayIndex];

      // Update count
      if (wasSelected) {
        setMonthDaysCount(count => count - 1);
      } else {
        setMonthDaysCount(count => count + 1);
      }

      return { ...prev, month_days: newMonthDays };
    });
  };

  // Helper function to get the recurrence type label for repeat interval
  const getRecurrenceTypeLabel = () => {
    const labels = {
      daily: 'day',
      weekly: 'week',
      monthly: 'month',
      yearly: 'year'
    };
    const label = labels[formData.recurrence_type] || 'day';
    return formData.repeat_interval === 1 ? label : `${label}s`;
  };

  // Get the actual start date based on the selected option
  const getActualStartDate = () => {
    if (formData.start_date_option === "custom" && formData.start_date) {
      return formData.start_date;
    } else if (formData.start_date_option === "tomorrow") {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.toISOString();
    }
    return null;
  };

  // Validate form using Yup schema
  const validateForm = async () => {
    try {
      await recurringValidationSchema.validate(formData, { abortEarly: false });
      setValidationErrors({});
      return true;
    } catch (error) {
      const errors = {};
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
      setValidationErrors(errors);
      return false;
    }
  };

  const handleSave = async () => {
    // Enable validation error display
    setShowValidationErrors(true);
    
    // Validate form before saving
    const isValid = await validateForm();
    if (!isValid) {
      return;
    }

    // Additional validation for weekly and monthly recurrence
    if (formData.recurrence_type === 'weekly' && weekDaysCount === 0) {
      setValidationErrors((prev) => ({
        ...prev,
        week_days: "At least one day must be selected for weekly recurrence",
      }));
      return;
    }
    if (formData.recurrence_type === 'monthly' && monthDaysCount === 0) {
      setValidationErrors((prev) => ({
        ...prev,
        month_days: "At least one day must be selected for monthly recurrence",
      }));
      return;
    }

    // Convert frontend data to backend format matching the API schema
    const backendData = {
      is_recurring: formData.is_recurring,
      recurrence_type: formData.recurrence_type,
      start_date: formData.start_date_option === "custom" ? formData.start_date :
        formData.start_date_option === "today" ? new Date().toISOString() :
        formData.start_date_option === "tomorrow" ? new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString() : null,
      end_time: formData.end_time,
      repeat_interval: formData.repeat_interval,
      week_days: (formData.recurrence_type === 'weekly' && weekDaysCount > 0) ? formData.week_days : null,
      month_days: (formData.recurrence_type === 'monthly' && monthDaysCount > 0) ? formData.month_days : null,
      skip_weekends: formData.recurrence_type === 'daily' ? formData.skip_weekends : null,
      due_date_offset: formData.due_date_option === "custom" ? "custom" : formData.due_date_option,
      custom_due_date_offset: (formData.due_date_option === "custom" && formData.custom_due_date_offset && formData.custom_due_date_offset >= 0) ? formData.custom_due_date_offset : null,
      end_condition: formData.end_condition,
      default_status: formData.default_status,
    };

    // Set all fields to Formik
    Object.keys(backendData).forEach(key => {
      setFieldValue(key, backendData[key]);
    });

    setModalState((prev) => ({ ...prev, isModalOpen: false }));
  };

  const weekDays = [
    { short: 'SU', full: 'Sunday', value: 0, label: 'Sunday' },
    { short: 'M', full: 'Monday', value: 1, label: 'Monday' },
    { short: 'T', full: 'Tuesday', value: 2, label: 'Tuesday' },
    { short: 'W', full: 'Wednesday', value: 3, label: 'Wednesday' },
    { short: 'T', full: 'Thursday', value: 4, label: 'Thursday' },
    { short: 'F', full: 'Friday', value: 5, label: 'Friday' },
    { short: 'S', full: 'Saturday', value: 6, label: 'Saturday' }
  ];

  const recurrenceTypes = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'yearly', label: 'Yearly' }
  ];

  const startDateOptions = [
    { value: 'tomorrow', label: 'Tomorrow' },
    { value: 'custom', label: 'Custom Date' }
  ];

  const dueDateOptions = [
    { value: 'same_day', label: 'Same day' },
    { value: 'next_day', label: 'Next day' },
    { value: '2_day', label: 'in 2 day' },
    { value: '3_day', label: 'in 3 day' },
    { value: '4_day', label: 'in 4 day' },
    { value: '5_day', label: 'in 5 day' },
    { value: 'custom', label: 'Custom' }
  ];

  const statusOptions = [
    { value: 'To Do', label: 'To Do' },
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Done', label: 'Done' }
  ];

  const renderRecurrenceTypeSelector = () => (
    <div className="interval-container">
      <div className="interval-controls">
        <div>
          <span className="interval-label">Recurrence Type</span>
          <SelectDropdown
            id="recurrence-type"
            selectedValue={formData.recurrence_type}
            onChange={(value) => handleChange('recurrence_type', value)}
            data={recurrenceTypes}
            classes="recurrence-select"
            placeholder="Select type"
            isClearable={false}
          />
          <Error error={showValidationErrors ? validationErrors.recurrence_type : null} />
        </div>
        <div className="interval-repeatevery">
          <span className="interval-label">Repeat every {formData.repeat_interval} {getRecurrenceTypeLabel()}</span>
          <div className="interval-input">
            <button
              type="button"
              className="interval-button"
              onClick={() => handleChange('repeat_interval', Math.max(1, formData.repeat_interval - 1))}
            >
              <Minus size={16} />
            </button>
            <span className="interval-value">{formData.repeat_interval}</span>
            <button
              type="button"
              className="interval-button"
              onClick={() => handleChange('repeat_interval', formData.repeat_interval + 1)}
            >
              <Plus size={16} />
            </button>
          </div>
          <Error error={showValidationErrors ? validationErrors.repeat_interval : null} />
        </div>
      </div>
    </div>
  );

  const renderDailyOptions = () => {
    if (formData.recurrence_type !== 'daily') return null;

    return (
      <div className="daily-options">
        <div className="checkwrapper">
          <CheckboxWrapper
            onChange={(e) => handleChange('skip_weekends', e.target.checked)}
            checked={formData.skip_weekends}
          />
        </div>
        <div>
          <span className="checkbox-span">Skip Weekends</span>
        </div>
      </div>
    );
  };

  const renderWeeklyOptions = () => {
    if (formData.recurrence_type !== 'weekly') return null;

    return (
      <div className="weekly-options">
        <div className="weekly-label-container">
          <span className="weekly-label">Days of week ({weekDaysCount} selected)</span>
        </div>
        <div className="weekday-buttons">
          {weekDays.map((day) => (
            <button
              key={day.full}
              type="button"
              className={`weekday-button ${formData.week_days[day.value] ? 'active' : ''}`}
              onClick={() => handleWeekDayToggle(day.value)}
            >
              {day.short}
            </button>
          ))}
        </div>
        <Error error={showValidationErrors ? validationErrors.week_days : null} />
      </div>
    );
  };

  const renderMonthlyOptions = () => {
    if (formData.recurrence_type !== 'monthly') return null;

    return(
      <div className="monthly-options">
        <div className="monthly-label-container">
          <span className="monthly-label">Days of month ({monthDaysCount} selected)</span>
        </div>
        <div className="date-grid">
          {Array.from({ length: 31 }, (_, i) => i + 1).map((date) => (
            <button
              key={date}
              type="button"
              className={`date-button ${formData.month_days[date - 1] ? 'active' : ''}`}
              onClick={() => handleMonthDayToggle(date - 1)}
            >
              {date}
            </button>
          ))}
        </div>
        <Error error={showValidationErrors ? validationErrors.month_days : null} />
      </div>
    );
  };

  const renderYearlyOptions = () => {
    if (formData.recurrence_type !== 'yearly') return null;

    return (
      <div className="yearly-options">
        <div className="yearly-label-container">
          <span className="yearly-label">Will repeat yearly based on the start date</span>
        </div>
      </div>
    );
  };

  const renderDateOptions = () => (
    <div className="date-options">
      <div className="date-control">
        <span className="date-label required-field">Repeat start date</span>
        <SelectDropdown
          id="start-date"
          selectedValue={formData.start_date_option}
          onChange={(value) => handleChange('start_date_option', value)}
          data={startDateOptions}
          classes="date-select full"
          placeholder="Select date"
          isClearable={false}
        />
        {formData.start_date_option === 'custom' && (
          <div className="custom-date-container">
            <DateSelector
              selectedDate={formData.start_date}
              onChange={(date) => handleChange('start_date', date)}
              placeholder="Select start date *"
              disablePast={true}
            />
            <Error error={showValidationErrors ? validationErrors.start_date : null} />
          </div>
        )}
      </div>

      <div className="date-control">
        <span className="date-label">Due date</span>
        <SelectDropdown
          id="due-date"
          selectedValue={formData.due_date_option}
          onChange={(value) => handleChange('due_date_option', value)}
          data={dueDateOptions}
          onClear={() => setFieldValue("due_date_option", [])}
          classes="date-select full"
          placeholder="Select due date"
          isClearable={true}
        />
        {formData.due_date_option === 'custom' && (
          <div className="custom-date-container">
            <div className="custom-due-date-input">
              <input
                type="number"
                value={formData.custom_due_date_offset || ''}
                onChange={(e) => handleChange('custom_due_date_offset', parseInt(e.target.value) || 0)}
                placeholder="Days Offset"
                min="0"
              />
              <Error error={showValidationErrors ? validationErrors.custom_due_date_offset : null} />
            </div>
          </div>
        )}
      </div>

      <div className="date-control">
        <span className="date-label required-field">Repeat end date</span>
        <div className="custom-date-container">
          <DateSelector
            selectedDate={formData.end_time}
            onChange={(date) => handleChange('end_time', date)}
            placeholder="Select end date *"
            disablePastToday={true}
            minDateData={getActualStartDate()}
          />
          <Error error={showValidationErrors ? validationErrors.end_time : null} />
        </div>
      </div>

      <div className="date-control">
        <span className="date-label">Default status</span>
        <SelectDropdown
          id="default-status"
          selectedValue={formData.default_status}
          onChange={(value) => handleChange('default_status', value)}
          data={status}
          onClear={() => setFieldValue("default_status", [])}
          classes="date-select full"
          placeholder="Select status"
          isClearable={true}
        />
      </div>
    </div>
  );

  // Disable save button if there are validation errors or if weekly/monthly recurrence has no days selected
  const isSaveDisabled = Object.keys(validationErrors).length > 0 ||
    (formData.recurrence_type === 'weekly' && weekDaysCount === 0) ||
    (formData.recurrence_type === 'monthly' && monthDaysCount === 0);

  return (
    <div className="form-container">
      {renderRecurrenceTypeSelector()}
      {renderDailyOptions()}
      {renderWeeklyOptions()}
      {renderMonthlyOptions()}
      {renderYearlyOptions()}
      {renderDateOptions()}

      <div className="form-actions">
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={() => setModalState((prev) => ({ ...prev, isModalOpen: false }))}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          disabled={isSaveDisabled}
          onClick={handleSave}
        >
          Save
        </button>
      </div>
    </div>
  );
};

// The rest of the Recurring component remains unchanged

const Recurring = ({ setFieldValue, values, setEndRepeats, status, initialValues , statusValue }) => {

  const [modalState, setModalState] = useState({
    isModalOpen: false,
    isDeleteModalOpen: false,
    modalId: "",
  });

  const isDateInPast = (dateString) => {
    if (!dateString) return false;
    const date = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  };

  const getEndRepeatsStatus = () => {
    const isRecurringEnded = initialValues?.is_recurring_ended;
    const recurringDate = initialValues?.recurring_date;

    if (isRecurringEnded === true) {
      return {
        disabled: true,
        tooltipMessage: "Recurring ended"
      };
    }

    if (!isRecurringEnded && isDateInPast(recurringDate)) {
      return {
        disabled: true,
        tooltipMessage: "You can't end this repeat"
      };
    }

    return {
      disabled: false,
      tooltipMessage: null
    };
  };

  const endRepeatsStatus = getEndRepeatsStatus();

  const handleOpenModal = (title) => {
    const modalId = uuidv4();
    setModalState((prev) => ({
      ...prev,
      isModalOpen: true,
      modalId,
      title,
    }));
  };

  const handleOpenDeleteModal = () => {
    if (endRepeatsStatus.disabled) return;

    const modalId = uuidv4();
    setModalState((prev) => ({
      ...prev,
      isDeleteModalOpen: true,
      modalId,
    }));
  };

  const handleCloseModal = () => {
    setModalState((prev) => ({
      ...prev,
      isModalOpen: false,
      isDeleteModalOpen: false,
    }));
  };

  const handleEndRepeats = () => {
    setFieldValue("is_recurring", false);
    setFieldValue("recurrence_type", null);
    setFieldValue("start_date", null);
    setFieldValue("end_time", null);
    setFieldValue("repeat_interval", null);
    setFieldValue("week_days", null);
    setFieldValue("month_days", null);
    setFieldValue("skip_weekends", null);
    setFieldValue("due_date_offset", null);
    setFieldValue("custom_due_date_offset", null);
    setFieldValue("end_condition", null);
    setEndRepeats?.(true);
    handleCloseModal();
  };

  const EndRepeatsButton = () => {
    const button = (
      <div className={endRepeatsStatus.disabled ? 'disabled-button-wrapper' : ''}>
        <CustomButton
          icon={<Repeat size={16} />}
          text="End Repeats"
          handleClick={handleOpenDeleteModal}
          disabled={endRepeatsStatus.disabled}
        />
      </div>
    );

    if (endRepeatsStatus.tooltipMessage) {
      return (
        <div
          className="tooltip-wrapper"
          title={endRepeatsStatus.tooltipMessage}
          style={{ cursor: endRepeatsStatus.disabled ? 'not-allowed' : 'pointer' }}
        >
          {button}
        </div>
      );
    }

    return button;
  };

  return (
    <>
      {values?.is_recurring ? (
        <EndRepeatsButton />
      ) : (
        <CustomButton
          icon={<Repeat size={16} />}
          text="Set Repeats"
          handleClick={() => handleOpenModal("Set Repeats")}
          disabled={statusValue === "Completed"}
        />
      )}

      {modalState.isModalOpen && (
        <Modal
          id={modalState.modalId}
          title={modalState.title}
          isActive={modalState.isModalOpen}
          onClose={handleCloseModal}
          width="700px"
          paddingProp={true}
        >
          <RecurringForm
            status={status}
            setModalState={setModalState}
            setFieldValue={setFieldValue}
            values={values}
          />
        </Modal>
      )}

      {modalState.isDeleteModalOpen && (
        <DeleteModal
          id={modalState.modalId}
          isActive={modalState.isDeleteModalOpen}
          onClose={handleCloseModal}
          type="End Repeats"
          description="Are you sure you want to end repeats for this task?"
          onClick={handleEndRepeats}
        />
      )}
    </>
  );
};

export default Recurring;
